export default [
  {
    key: "A",
    value: "A"
  },
  {
    key: "A6",
    value: "A6"
  },
  {
    key: "AAAA",
    value: "AAAA"
  },
  {
    key: "AFSDB",
    value: "AFSDB"
  },
  {
    key: "APL",
    value: "APL"
  },
  {
    key: "ATMA",
    value: "ATMA"
  },
  {
    key: "CAA",
    value: "CAA"
  },
  {
    key: "CERT",
    value: "CERT"
  },
  {
    key: "CNAME",
    value: "CNAME"
  },

  {
    key: "DNAME",
    value: "DNAME"
  },

  {
    key: "DNSKey",
    value: "DNSKey"
  },

  {
    key: "DS",
    value: "DS"
  },

  {
    key: "EID",
    value: "EID"
  },

  {
    key: "GID",
    value: "GID"
  },

  {
    key: "GPOS",
    value: "GPOS"
  },
  {
    key: "HINFO",
    value: "HINFO"
  },

  {
    key: "ISDN",
    value: "ISDN"
  },

  {
    key: "KEY",
    value: "KEY"
  },
  {
    key: "KX",
    value: "KX"
  },
  {
    key: "LOC",
    value: "LOC"
  },
  {
    key: "MB",
    value: "MB"
  },
  {
    key: "MD",
    value: "MD"
  },
  {
    key: "MF",
    value: "MF"
  },
  {
    key: "MG",
    value: "MG"
  },
  {
    key: "MINFO",
    value: "MINFO"
  },
  {
    key: "MR",
    value: "MR"
  },
  {
    key: "MX",
    value: "MX"
  },
  {
    key: "NAPTR",
    value: "NAPTR"
  },
  {
    key: "NIMLOC",
    value: "NIMLOC"
  },
  {
    key: "NSEC",
    value: "NSEC"
  },
  {
    key: "NSEC3",
    value: "NSEC3"
  },
  {
    key: "NSEC3PARAM",
    value: "NSEC3PARAM"
  },
  {
    key: "NULL",
    value: "NULL"
  },
  {
    key: "NS",
    value: "NS"
  },
  {
    key: "NSAP",
    value: "NSAP"
  },
  {
    key: "NSAP-PTR",
    value: "NSAP-PTR"
  },

  {
    key: "NXT",
    value: "NXT"
  },
  {
    key: "OPT",
    value: "OPT"
  },
  {
    key: "PTR",
    value: "PTR"
  },
  {
    key: "PX",
    value: "PX"
  },
  {
    key: "RP",
    value: "RP"
  },
  {
    key: "RRSIG",
    value: "RRSIG"
  },
  {
    key: "RT",
    value: "RT"
  },
  {
    key: "SIG",
    value: "SIG"
  },
  {
    key: "SINK",
    value: "SINK"
  },
  {
    key: "SOA",
    value: "SOA"
  },

  {
    key: "SPF",
    value: "SPF"
  },
  {
    key: "SRV",
    value: "SRV"
  },
  {
    key: "SSHFP",
    value: "SSHFP"
  },
  {
    key: "TKEY",
    value: "TKEY"
  },
  {
    key: "TLSA",
    value: "TLSA"
  },
  {
    key: "TSIG",
    value: "TSIG"
  },
  {
    key: "TXT",
    value: "TXT"
  },
  {
    key: "UID",
    value: "UID"
  },
  {
    key: "UINFO",
    value: "UINFO"
  },

  {
    key: "UNSPEC",
    value: "UNSPEC"
  },
  {
    key: "WKS",
    value: "WKS"
  },
  {
    key: "X25",
    value: "X25"
  }
];



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/dns-tool-form/dns-records.js